import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ProvinceStateViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  name_esValue?: { displayId: string; id: string } | null;
  name_es: string;
  name_enValue?: { displayId: string; id: string } | null;
  name_en: string;
  name_ptValue?: { displayId: string; id: string } | null;
  name_pt: string;
  countryValue: { displayId: string; id: string } | null;
};

export const ProvinceStateViewForm: React.FC<ProvinceStateViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name_es = "",
      name_en = "",
      name_pt = "",
      countryValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupProvinceStateLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name_es}
                  label={langStore.ProvinceStateNameLabel + " (es)"}
                />
                ,
                <ShowMultiLine
                  value={name_en}
                  label={langStore.ProvinceStateNameLabel + " (en)"}
                />
                ,
                <ShowMultiLine
                  value={name_pt}
                  label={langStore.ProvinceStateNameLabel + " (pt)"}
                />
                <ShowReference
                  label={langStore.ProvinceStateCountryLabel}
                  selectedValue={langStore.displayIdByLang(
                    countryValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
